import { object, ObjectSchema, string } from "yup";

export interface ConfirmSignInFormData {
  code: string;
}

export const defaultValues: ConfirmSignInFormData = {
  code: "",
};

export const validationSchema: ObjectSchema<ConfirmSignInFormData> = object({
  code: string()
    .min(6, "Code must be 6 characters")
    .required("Code is required"),
});
